import { cilX } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import React, { useEffect, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { convertPointsToSVG, svgToBase64 } from 'src/helpers/dataURLtoFile';
// eslint-disable-next-line react/prop-types
const SignatureBoard = ({ label, signature, setSignature, width }) => {
  useEffect(() => {
    if (signature !== '') {
      const base64 = svgToBase64(signature);
      ref.current.fromDataURL(base64);
    }
  }, []);

  const ref = useRef(null);

  const clearCanvas = () => {
    ref.current.clear();
    setSignature('');
  };

  const saveCanvas = () => {
    const image = ref.current.toData(); //getTrimmedCanvas().toDataURL('image/png');
    if (!ref.current.isEmpty()) {
      const svg = convertPointsToSVG(image);
      setSignature(svg);
    }
  };
  return (
    <React.Fragment>
      {label && (
        <label className="login_label labelName mt-2 mb-2 d-block text-start">{label}</label>
      )}
      <div className="image-container" aria-disabled="true">
        <SignatureCanvas
          ref={ref}
          dotSize={2}
          penColor="white"
          trailingStroke={true}
          lineWidth={3}
          onEnd={saveCanvas}
          canvasProps={{
            width: window.innerWidth < 768 ? 340 : width ?? 400, // 👈 responsive width
            height: 200,
            className: 'sigCanvas',
          }}
        />

        <CIcon
          icon={cilX}
          title="Clear"
          className="canvas-icon ms-4"
          size="xl"
          onClick={clearCanvas}
        />
      </div>
    </React.Fragment>
  );
};
export default SignatureBoard;
